"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeLanguageFromPathname = void 0;
/**
 * Removes language from the beginning of given pathname.
 *
 * @example
 * pathname: /ru/something
 * locale: ru-MD
 * Result: /something
 *
 * @param pathname - Pathname where language will be removed.
 * @param locale - Locale code.
 * @returns Pathname with removed language from its beginning.
 */
const removeLanguageFromPathname = (pathname, locale) => {
  const matched = locale.match(/^([a-z]+)-/) ?? [];
  const [, language] = matched;
  if (!language) {
    return pathname;
  }
  return pathname.replace(new RegExp(`^/${language}`), '');
};
exports.removeLanguageFromPathname = removeLanguageFromPathname;
